/* eslint-disable no-unused-vars */
/* eslint-disable */
import { Dispatch } from 'redux';
import { Permission } from 'src/config/permissions';
import { IEmailSignin, ISignin, ITrustedDeviceSignin } from 'src/interfaces';
import signinService from 'src/services/signin.service';
import { clearTrustedDeviceToken, saveTrustedDeviceToken } from 'src/utils/trustedDevice';

import { AuthActionType } from '../action-types';
import { AuthAction } from '../actions';

enum PermissionType {
  EMPLOYEE = 'employee',
  EXTERNAL_MANAGER = 'external_manager',
  ADMIN = 'admin',
}

interface IAuthPermissions {
  permissions: string[];
  roleName: string;
}

// eslint-disable-next-line @typescript-eslint/no-shadow
export const signin = (signin: ISignin) => async (dispatch: Dispatch<AuthAction>) => {
  dispatch({
    type: AuthActionType.SIGNIN,
  });

  try {
    const { data } = await signinService.signin(signin);
    if (data?.trustedDeviceToken) {
      saveTrustedDeviceToken(signin.username, data.trustedDeviceToken);
    }
    // ----------
    const roles = data.permissions || [];
    const roleNames = roles.map((r: any) => r.roleName);
    const permissionsFromRoles = roles.flatMap((r: any) => r.permissions || []);
    // const modules = Array.from(
    //   new Set([Permission.HOME, ...permissionsFromRoles])
    // );

    const hasEmployee = roleNames.includes(PermissionType.EMPLOYEE);
    const hasAdmin = roleNames.includes(PermissionType.ADMIN);
    const hasExternalManager = roleNames.includes(PermissionType.EXTERNAL_MANAGER);

    const modules = Array.from(
      new Set([...(hasEmployee || hasAdmin ? [Permission.HOME] : []), ...permissionsFromRoles])
    );

    const { accessToken } = data;

    console.log('here the comig', data);
    // new one

    //     const allowedRoles = [
    //   PermissionType.EMPLOYEE,
    //   PermissionType.EXTERNAL_MANAGER,
    // ];

    // const rolePermissions = data.permissions.find(
    //   (permission: IAuthPermissions) =>
    //     allowedRoles.includes(permission.roleName as PermissionType)
    // );
    // const modules = rolePermissions?.permissions
    //   ? [...rolePermissions.permissions, Permission.HOME]
    //   : [Permission.HOME];

    const rolePermissions = data.permissions.find(
      (permission: IAuthPermissions) =>
        permission.roleName === PermissionType.EMPLOYEE ||
        permission.roleName === PermissionType.EXTERNAL_MANAGER ||
        permission.roleName === PermissionType.ADMIN
    );

    // const modules = rolePermissions?.permissions || [];

    // const modules = [
    //   Permission.HOME,
    //   ...(rolePermissions?.permissions || []),
    // ];

    let redirectPath = '/dashboard';
    let userRole = '';

    if (hasExternalManager) {
      redirectPath = '/invoices';
      userRole = PermissionType.EXTERNAL_MANAGER;
    } else if (hasAdmin) {
      redirectPath = '/dashboard';
      userRole = PermissionType.ADMIN;
    } else if (hasEmployee) {
      redirectPath = '/dashboard';
      userRole = PermissionType.EMPLOYEE;
    }

    //-------------------------------
    // let redirectPath = '/';
    // let userRole = ''
    // const rolePermissionsCheck = data.permissions.find(
    //   (permission: IAuthPermissions) =>
    //     userRole = permission.roleName
    // );

    // if (rolePermissions?.roleName === PermissionType.EXTERNAL_MANAGER) {
    //   redirectPath = '/invoices';
    // }
    // if (rolePermissions?.roleName === PermissionType.EMPLOYEE || rolePermissions?.roleName === PermissionType.ADMIN) {
    //   redirectPath = '/dashboard';
    // }

    // ---------------------

    // old one
    // const modules = data.permissions.find(
    //   (permission: IAuthPermissions) => permission.roleName === PermissionType.EMPLOYEE
    // ).permissions || [Permission.HOME];

    // dispatch({
    //   type: AuthActionType.SIGNIN_SUCCESS,
    //   payload: { accessToken, modules },
    // });

    // new one
    dispatch({
      type: AuthActionType.SIGNIN_SUCCESS,
      payload: {
        accessToken,
        modules,
        redirectPath,
        userRole,
      },
    });
  } catch (err: any) {
    dispatch({
      type: AuthActionType.SIGNIN_FAILURE,
      payload: err.response?.data?.message || err.message,
    });
  }
};

export const signinWithEmailCode = (signinData: IEmailSignin) => async (dispatch: Dispatch<AuthAction>) => {
  dispatch({
    type: AuthActionType.SIGNIN,
  });

  try {
    const { data } = await signinService.signinWithEmailCode(signinData);
    if (data?.trustedDeviceToken) {
      saveTrustedDeviceToken(signinData.username, data.trustedDeviceToken);
    }
    const roles = data.permissions || [];
    const roleNames = roles.map((r: any) => r.roleName);
    const permissionsFromRoles = roles.flatMap((r: any) => r.permissions || []);

    const hasEmployee = roleNames.includes(PermissionType.EMPLOYEE);
    const hasAdmin = roleNames.includes(PermissionType.ADMIN);
    const hasExternalManager = roleNames.includes(PermissionType.EXTERNAL_MANAGER);

    const modules = Array.from(
      new Set([...(hasEmployee || hasAdmin ? [Permission.HOME] : []), ...permissionsFromRoles])
    );

    const { accessToken } = data;

    let redirectPath = '/dashboard';
    let userRole = '';

    if (hasExternalManager) {
      redirectPath = '/invoices';
      userRole = PermissionType.EXTERNAL_MANAGER;
    } else if (hasAdmin) {
      redirectPath = '/dashboard';
      userRole = PermissionType.ADMIN;
    } else if (hasEmployee) {
      redirectPath = '/dashboard';
      userRole = PermissionType.EMPLOYEE;
    }

    dispatch({
      type: AuthActionType.SIGNIN_SUCCESS,
      payload: {
        accessToken,
        modules,
        redirectPath,
        userRole,
      },
    });
  } catch (err: any) {
    dispatch({
      type: AuthActionType.SIGNIN_FAILURE,
      payload: err.response?.data?.message || err.message,
    });
  }
};

export const signinDirect =
  (result: { accessToken: string; permissions: any[] }) => (dispatch: Dispatch<AuthAction>) => {
    const roles = result.permissions || [];
    const roleNames = roles.map((r: any) => r.roleName);
    const permissionsFromRoles = roles.flatMap((r: any) => r.permissions || []);

    const hasEmployee = roleNames.includes(PermissionType.EMPLOYEE);
    const hasAdmin = roleNames.includes(PermissionType.ADMIN);
    const hasExternalManager = roleNames.includes(PermissionType.EXTERNAL_MANAGER);

    const modules = Array.from(
      new Set([...(hasEmployee || hasAdmin ? [Permission.HOME] : []), ...permissionsFromRoles])
    );

    let redirectPath = '/dashboard';
    let userRole = '';

    if (hasExternalManager) {
      redirectPath = '/invoices';
      userRole = PermissionType.EXTERNAL_MANAGER;
    } else if (hasAdmin) {
      redirectPath = '/dashboard';
      userRole = PermissionType.ADMIN;
    } else if (hasEmployee) {
      redirectPath = '/dashboard';
      userRole = PermissionType.EMPLOYEE;
    }

    dispatch({
      type: AuthActionType.SIGNIN_SUCCESS,
      payload: { accessToken: result.accessToken, modules, redirectPath, userRole },
    });
  };

// Sign in directly using the username/password plus a previously issued
// trusted-device token. On success the server returns a fresh
// trustedDeviceToken which slides the 15-day window forward. If the server
// rejects the token (expired/invalid) we clear the stored token and rethrow
// so the caller can transparently fall back to the regular MFA/email-code
// flow without surfacing an error to the user.
export const signinWithTrustedDevice = (signinData: ITrustedDeviceSignin) => async (dispatch: Dispatch<AuthAction>) => {
  let data: any;
  try {
    const response = await signinService.signinWithTrustedDevice(signinData);
    data = response.data;
  } catch (err) {
    clearTrustedDeviceToken(signinData.username);
    throw err;
  }

  if (data?.trustedDeviceToken) {
    saveTrustedDeviceToken(signinData.username, data.trustedDeviceToken);
  }

  const roles = data.permissions || [];
  const roleNames = roles.map((r: any) => r.roleName);
  const permissionsFromRoles = roles.flatMap((r: any) => r.permissions || []);

  const hasEmployee = roleNames.includes(PermissionType.EMPLOYEE);
  const hasAdmin = roleNames.includes(PermissionType.ADMIN);
  const hasExternalManager = roleNames.includes(PermissionType.EXTERNAL_MANAGER);

  const modules = Array.from(new Set([...(hasEmployee || hasAdmin ? [Permission.HOME] : []), ...permissionsFromRoles]));

  const { accessToken } = data;

  let redirectPath = '/dashboard';
  let userRole = '';

  if (hasExternalManager) {
    redirectPath = '/invoices';
    userRole = PermissionType.EXTERNAL_MANAGER;
  } else if (hasAdmin) {
    redirectPath = '/dashboard';
    userRole = PermissionType.ADMIN;
  } else if (hasEmployee) {
    redirectPath = '/dashboard';
    userRole = PermissionType.EMPLOYEE;
  }

  dispatch({
    type: AuthActionType.SIGNIN_SUCCESS,
    payload: {
      accessToken,
      modules,
      redirectPath,
      userRole,
    },
  });
};
